(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpDualDatatable', cpDualDatatable);

    cpDualDatatable.$inject = ['lodashService', '$timeout', '$window'];

    function cpDualDatatable(lodashService, $timeout, $window) {
        return {
            restrict: 'E',
            replace: true,
            transclude: {
                'left': '?left',
                'right': '?right'
            },
            scope: {
                hideOrderCol: '@',
                cols: '=',

                filtersOnTopLeft: '@?',
                filtersOnBottomLeft: '@?',
                filtersOnTopRight: '@?',
                filtersOnBottomRight: '@?',

                titleLeft: '@',
                titleRight: '@',

                loadingLeft: '=?',
                loadingRight: '=?',

                rowsLeft: '=',
                rowsRight: '=',

                modelPermissionsLeft: '=?',
                modelPermissionsRight: '=?',

                onCreateLeft: '&?',
                onEditLeft: '&?',
                extraActionsLeft: '=?',
                onCreateRight: '&?',
                onEditRight: '&?',
                extraActionsRight: '=?',

                pageOptsLeft: '=?',
                pageChangeLeft: '&?',
                pageOptsRight: '=?',
                pageChangeRight: '&?',

                summaryColsLeft: '=?',
                withSearchLeft: '=?',
                searchQueryLeft: '=?',
                onSearchQueryChangeLeft: '&?',
                summaryColsRight: '=?',
                withSearchRight: '=?',
                searchQueryRight: '=?',
                onSearchQueryChangeRight: '&?',

                onMoveToLeft: '&?',
                onMoveToRight: '&?',

                withExposing: '=?',
                exposingColors: '=?',
                exposingConditionProp: '=?',
                exposingConditionValue: '=?'
            },
            templateUrl: 'app/caffeprint/directives/dual-datatable/dual-datatable.html',
            link: function(scope, element, attrs) {
                scope.runOnEditLeft = runOnEditLeft;
                scope.runOnEditRight = runOnEditRight;

                scope.checkboxSelectedProp = "$$checkboxSelected";

                angular.element($window).bind("scroll", function() {
                    if (this.pageYOffset >= angular.element('.montages')[0].offsetTop - ($window.innerHeight / 3) && this.pageYOffset < (angular.element('.montages')[0].offsetTop + angular.element('.montages')[0].offsetHeight)) {
                        $('.dual-buttons').addClass('fixed').css('top', this.pageYOffset - $window.innerHeight);
                    }
                });

                scope.toRightSelected = toRightSelected;
                scope.toRightAll = toRightAll;
                scope.toLeftAll = toLeftAll;
                scope.toLeftSelected = toLeftSelected;

                function moveElements(source, target, callback, moveAll) {
                    var movedObjects = [];

                    for (var i = 0; i < source.length; i++) {
                        if (source[i][scope.checkboxSelectedProp] || moveAll) {
                            source[i][scope.checkboxSelectedProp] = false;

                            var obj = source[i];
                            source.splice(i, 1);
                            --i;

                            movedObjects.push(obj);
                            target.push(obj);
                        }
                    }

                    if (callback) {
                        callback({ arr: movedObjects });
                    }
                }

                function toRightSelected() {
                    moveElements(scope.rowsLeft, scope.rowsRight, scope.onMoveToRight);
                }

                function toRightAll() {
                    moveElements(scope.rowsLeft, scope.rowsRight, scope.onMoveToRight, true);
                }

                function toLeftAll() {
                    moveElements(scope.rowsRight, scope.rowsLeft, scope.onMoveToLeft, true);
                }

                function toLeftSelected() {
                    moveElements(scope.rowsRight, scope.rowsLeft, scope.onMoveToLeft);
                }

                function runOnEditLeft(row) {
                    if (scope.onEditLeft) {
                        scope.onEditLeft({ row: row });
                    }
                }

                function runOnEditRight(row) {
                    if (scope.onEditRight) {
                        scope.onEditRight({ row: row });
                    }
                }
            }
        };
    }
})();
